module.exports = __webpack_public_path__ + "img/w3_circle_left_white.0e4f9d68.png";